import OrganisationProfileCard from './OrganisationProfileCard';

export default OrganisationProfileCard;